import axios, { AxiosError, type AxiosInstance } from 'axios';
import { useAuthStore } from '@/shared/stores/auth';
import { handleSessionReplaced, type ReplacedBy } from '@/shared/stores/sessionReplaced';

const baseURL = (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api/v1/merkaziya';

export const apiClient: AxiosInstance = axios.create({
  baseURL,
  timeout: 30_000,
  headers: {
    Accept: 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const { token, tenantSlug } = useAuthStore.getState();

  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }

  if (tenantSlug) {
    config.headers.set('X-Tenant-Slug', tenantSlug);
  }

  return config;
});

apiClient.interceptors.response.use(
  (resp) => resp,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      const body = error.response.data as { code?: string; replaced_by?: ReplacedBy } | undefined;
      if (body?.code === 'session_replaced') {
        // מישהו התחבר ממכשיר אחר — הודעה בולטת + יציאה (אחרי שיחה חיה, אם יש).
        void handleSessionReplaced(body.replaced_by);
      } else {
        useAuthStore.getState().clear();
      }
    }

    return Promise.reject(error);
  }
);

export interface ApiEnvelope<T> {
  success: boolean;
  data?: T;
  message?: string;
  meta?: Record<string, unknown>;
}
